import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import media from 'styles/tools/media'
import rem from 'styles/tools/rem'

import { linkNavyBlue, darkGrey, grey, offWhite, white, lightBlue } from 'styles/settings/colors'
import {
  txt12OpenSans,
  txt14OpenSans,
  txt14OpenSansBold,
  txt16OpenSans
} from 'styles/settings/types'

export const Separator = styled.hr`
  background-color: ${offWhite};
  border: 0;
  height: ${rem('1px')};
  margin: ${rem('20px')} 0;
`

export const Container = styled.div`
  width: 100%;

  ${({ typeAccountPos }) =>
    typeAccountPos &&
    `
      max-width: ${rem('500px')};
      padding: ${rem('32px')};
      background-color: ${white};
      border-radius: ${rem('4.4px')};
      border: solid ${rem('1px')} ${grey};
    `};
`

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const Title = styled.p`
  ${txt16OpenSans} color: ${linkNavyBlue};
  font-weight: bold;
  margin: 0;
`

export const EditItem = styled.p`
  ${txt14OpenSansBold};

  margin: 0 ${'8px'} 0 0;
  letter-spacing: ${rem('-0.4px')};
  color: ${({ typeAccountPos }) => (typeAccountPos ? lightBlue : linkNavyBlue)};
`

export const ContainerIcon = styled.div`
  margin-right: ${({ marginRight }) => (marginRight ? `${marginRight}px` : `${rem('8px')}`)};
  margin-left: ${({ marginLeft }) => (marginLeft ? `${marginLeft}px` : `0`)};
  align-items: center;
  align-self: ${({ alignSelf }) => alignSelf || `normal`};
`

export const PlanType = styled.p`
  ${txt14OpenSans} color: ${linkNavyBlue};
  margin: ${({ typeAccountPos }) => (typeAccountPos ? '8px 0 0' : '0')};;
`

export const EditData = styled(Link)`
  align-items: baseline;
  text-decoration: none;
`

export const EditDataPos = styled.span`
  align-items: baseline;
  text-decoration: none;
  cursor: pointer;
`

export const PaymentInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-left: ${rem('-36px')};

  ${media.large`
        flex-direction: row;
    `};
`

export const ListInfo = styled.div`
  display: flex;
  flex-direction: column;
`

export const PaymentItem = styled.div`
  align-items: ${({ typeAccountPos }) => (typeAccountPos ? 'flex-start' : 'center')};
  box-sizing: border-box;
  display: flex;
  margin-left: ${rem('36px')};
  margin-top: ${rem('22px')};

  ${({ grouped }) =>
    grouped &&
    css`
        ${media.small`
            padding-left: ${rem('50px')};
        `}
        & > ${ListInfo} + ${ListInfo} {
            margin-left: ${rem('36px')};
        }
    `};
`

export const Text = styled.p`
  margin: 0 ${rem('15px')};
`

export const InfoItem = styled.p`
  ${txt12OpenSans} color: ${darkGrey};
  letter-spacing: ${rem('1px')};
  margin: 0;
  text-transform: uppercase;
`

export const InfoItemAdditional = styled.p`
  ${txt14OpenSans} color: ${linkNavyBlue};
  font-weight: ${({ typeAccountPos }) => (typeAccountPos ? '600' : 'normal')};
  margin: 0;
`

export const PaymentFooter = styled.p`
  ${txt12OpenSans} color: ${darkGrey};
`

export const DropdownContainer = styled.div`
  display: flex;
  align-items: center;
  min-height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/app/modules/PaymentMethods/styles.js